import { PreviewCanvas } from '@/components/PreviewCanvas';
import { postSandboxReadyToShell } from '@/utils/postSandboxReady';
import {
  applyDesignTokens,
  bootstrapThemeFromPayload,
  type DesignTokens,
} from '@/utils/themeEngine';
import {
  buildGoogleFontsStylesheetHref,
  collectTypographyPresetFontFamilies,
} from '@web-studio/shared-schemas';
import { useLayoutEffect } from 'react';

const FALLBACK_TOKENS: DesignTokens = {
  colors: {
    brandPrimary: 'oklch(0.78 0.12 85)',
    brandAccent: 'oklch(0.85 0.1 90)',
  },
};

function ensureTypographyPresetFonts(): void {
  const href = buildGoogleFontsStylesheetHref(collectTypographyPresetFontFamilies());
  if (!href || typeof document === 'undefined') return;
  const id = 'ws-typography-preset-fonts';
  if (document.getElementById(id)) return;
  const link = document.createElement('link');
  link.id = id;
  link.rel = 'stylesheet';
  link.href = href;
  document.head.appendChild(link);
}

export function bootstrapSandboxTheme(): void {
  ensureTypographyPresetFonts();
  const injected = (
    globalThis as typeof globalThis & { __WEB_STUDIO_DESIGN_TOKENS__?: unknown }
  ).__WEB_STUDIO_DESIGN_TOKENS__;

  if (injected) {
    bootstrapThemeFromPayload(injected);
    return;
  }

  applyDesignTokens(FALLBACK_TOKENS);
}

export function App() {
  useLayoutEffect(() => {
    postSandboxReadyToShell();
  }, []);

  return (
    <div data-web-studio="sandbox-runtime">
      <PreviewCanvas />
    </div>
  );
}
